interface ReportTypeOption {
  label: string;
  value: number;
  pathname:
    | "/report/physical"
    | "/report/ent"
    | "/report/eye"
    | "/report/growth"
    | "/report/dental";
}

export const REPORT_TYPES: ReportTypeOption[] = [
  { label: "Physical", value: 5, pathname: "/report/physical" },
  { label: "ENT", value: 3, pathname: "/report/ent" },
  { label: "Eye", value: 4, pathname: "/report/eye" },
  { label: "Growth", value: 2, pathname: "/report/growth" },
  { label: "Dental", value: 6, pathname: "/report/dental" },
];
